export const LogoMark = ({ size = 30, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
        <defs>
            <linearGradient id="vl-silver" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#D4DAE1" />
                <stop offset="1" stopColor="#7E8995" />
            </linearGradient>
            <linearGradient id="vl-blue" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#2E86FF" />
                <stop offset="1" stopColor="#0050C8" />
            </linearGradient>
        </defs>
        <polygon points="8,4 34,4 57,96 31,96" fill="url(#vl-silver)" />
        <polygon points="66,4 92,4 69,96 43,96" fill="url(#vl-blue)" />
    </svg>
);

const Logo = ({ dark = false, tagline = false, size = 30 }) => (
    <span className="inline-flex flex-col gap-1 select-none" aria-label="Vantera — The Revenue Operating System">
        <span className="inline-flex items-center gap-2.5">
            <LogoMark size={size} />
            <span className={`font-display font-extrabold tracking-[0.14em] leading-none ${dark ? "text-ivory" : "text-ink"}`} style={{ fontSize: size * 0.62 }}>
                VANTERA
            </span>
        </span>
        {tagline && (
            <span className={`font-mono uppercase tracking-[0.32em] ${dark ? "text-cloud" : "text-slategray"}`} style={{ fontSize: Math.max(8, size * 0.2) }}>
                The Revenue Operating System
            </span>
        )}
    </span>
);

export default Logo;